export default __webpack_public_path__ + "static/media/sentiment_unsure.0948064d.svg";